<template>
  <sistema>
    <container>
      <template v-slot:header>
        <h3>Robôs &amp; Filas</h3>
      </template>
      <template v-slot:body>
        <div>
          <div class="saldos-captcha">
            <div class="saldo-card saldo-anticaptcha">
              <i class="pi pi-unlock saldo-icon"></i>
              <div class="saldo-info">
                <span class="saldo-label">Saldo AntiCaptcha</span>
                <span class="saldo-valor"
                  >{{ state.saldoAntiCaptcha ?? "—" }}$</span
                >
              </div>
            </div>
            <div class="saldo-card saldo-hcaptcha">
              <i class="pi pi-key saldo-icon"></i>
              <div class="saldo-info">
                <span class="saldo-label">Saldo Hcaptcha</span>
                <span class="saldo-valor"
                  >{{ state.saldoHcaptcha ?? "—" }} Tokens</span
                >
              </div>
            </div>
          </div>
          <Panel
            class="controle-orgao-panel"
            header="Controle de Robôs"
            :toggleable="true"
          >
            <DataTable
              class="p-datatable-sm controle-geral-table"
              responsiveLayout="stack"
              breakpoint="60rem"
              :value="controleGeralRows"
            >
              <Column field="nome" header="Robô">
                <template #body="{ data }">
                  <span :class="orgaoStatusClass(data)">{{ data.nome }}</span>
                </template>
              </Column>
              <Column header="Consulta" style="width: 8rem;">
                <template #body="{ data }">
                  <InputSwitch
                    :modelValue="data.consultaHabilitado"
                    @update:modelValue="toggleConsultaGeral"
                  />
                </template>
              </Column>
              <Column header="Cadastro" style="width: 8rem;">
                <template #body="{ data }">
                  <InputSwitch
                    :modelValue="data.cadastroHabilitado"
                    @update:modelValue="toggleCadastroGeral"
                  />
                </template>
              </Column>
            </DataTable>
            <DataTable
              class="p-datatable-sm"
              responsiveLayout="stack"
              breakpoint="60rem"
              :stripedRows="true"
              :loading="state.loadingOrgaos"
              :value="state.orgaosRobo"
            >
              <Column field="sigla" header="Órgão">
                <template #body="{ data }">
                  <div class="orgao-cell">
                    <span class="orgao-logo">
                      <orgao-art-img v-if="data.art" :idOrgao="data.idOrgao" />
                      <orgao-aet-img v-else :idOrgao="data.idOrgao" />
                    </span>
                    <span :class="orgaoStatusClass(data)">
                      {{ data.sigla }} - {{ data.nome }}
                    </span>
                  </div>
                </template>
              </Column>
              <Column header="Consulta" style="width: 8rem;">
                <template #body="{ data }">
                  <InputSwitch
                    :modelValue="data.consultaHabilitado"
                    @update:modelValue="(v) => toggleConsultaOrgao(data, v)"
                  />
                </template>
              </Column>
              <Column header="Cadastro" style="width: 8rem;">
                <template #body="{ data }">
                  <InputSwitch
                    :modelValue="data.cadastroHabilitado"
                    @update:modelValue="(v) => toggleCadastroOrgao(data, v)"
                  />
                </template>
              </Column>
            </DataTable>
          </Panel>
          <Panel
            class="fila-robos-panel"
            header="Fila de Robôs"
            :toggleable="true"
            :collapsed="false"
          >
            <template #icons>
              <span
                v-if="state.results.page.totalElements"
                class="search-result-count"
              >
                {{ state.results.page.totalElements }} registro{{
                  state.results.page.totalElements !== 1 ? "s" : ""
                }}
              </span>
              <Button
                icon="pi pi-refresh"
                class="p-button-rounded p-button-text"
                :loading="state.loadingFila"
                v-title="'Atualizar'"
                @click="executeSearchFilaRobo"
              />
            </template>
            <DataTable
              class="p-datatable-sm fila-robos-table"
              responsiveLayout="stack"
              breakpoint="60rem"
              :stripedRows="true"
              :value="state.results.content"
            >
              <Column style="white-space: pre-line;" field="fila" header="Fila">
                <template #body="{ data }">
                  {{ getFila(data) }}
                </template>
              </Column>
              <Column
                style="white-space: pre-line;"
                field="sigla"
                header="Sigla"
              >
                <template #body="{ data }">
                  <div class="orgao-cell">
                    <span class="orgao-logo">
                      <orgao-aet-img
                        v-if="getIdOrgaoAetBySigla(getSigla(data))"
                        :idOrgao="getIdOrgaoAetBySigla(getSigla(data))"
                      />
                      <orgao-art-img
                        v-else-if="getIdOrgaoArtBySigla(getSigla(data))"
                        :idOrgao="getIdOrgaoArtBySigla(getSigla(data))"
                      />
                    </span>
                    <span>{{ getSigla(data) }}</span>
                  </div>
                </template>
              </Column>
              <Column
                style="white-space: pre-line;"
                field="statusRobo"
                header="Status Robo"
              >
                <template #body="{ data }">
                  {{ getStatusRobo(data) }}
                </template>
              </Column>
              <Column
                style="white-space: pre-line;"
                field="qtde"
                header="Quantidade"
              >
                <template #body="{ data }">
                  {{ getQuantidade(data) }}
                </template>
              </Column>
            </DataTable>
          </Panel>
          <Panel
            class="fila-art-panel"
            header="Fila ARTS"
            :toggleable="true"
            :collapsed="false"
          >
            <template #icons>
              <span
                v-if="filaArtRef?.results?.content?.length"
                class="search-result-count"
              >
                {{ filaArtRef.results.content.length }} registro{{
                  filaArtRef.results.content.length !== 1 ? "s" : ""
                }}
              </span>
              <Button
                icon="pi pi-refresh"
                class="p-button-rounded p-button-text"
                :loading="!!filaArtRef?.stateLoading"
                v-title="'Atualizar'"
                @click="filaArtRef?.submitSearch()"
              />
            </template>
            <crud-art-engenheiro-transportador ref="filaArtRef" />
          </Panel>
          <Panel
            class="fila-rntrc-panel"
            header="Fila RNTRC"
            :toggleable="true"
            :collapsed="false"
          >
            <template #icons>
              <span
                v-if="filaRntrcRef?.linhas?.length"
                class="search-result-count"
              >
                {{ filaRntrcRef.linhas.length }} registro{{
                  filaRntrcRef.linhas.length !== 1 ? "s" : ""
                }}
              </span>
              <Button
                icon="pi pi-refresh"
                class="p-button-rounded p-button-text"
                :loading="!!filaRntrcRef?.stateLoading"
                v-title="'Atualizar'"
                @click="filaRntrcRef?.submitSearch()"
              />
            </template>
            <fila-rntrc-painel ref="filaRntrcRef" />
          </Panel>
        </div>
      </template>
    </container>
  </sistema>
</template>

<script lang="ts">
import { useAuth, PermissionPayload } from "../../modules/auth";
import CrudArtEngenheiroTransportador from "../../components/transportador/art/CrudArtEngenheiroTransportador.vue";
import FilaRntrcPainel from "../../components/rntrc/FilaRntrcPainel.vue";
import {
  useDashboardService,
  DashboarPayload,
  OrgaoRoboStatusPayload
} from "../../modules/business/cliente/dashboardBusiness";
import { defineComponent, reactive, computed, onMounted, ref } from "vue";
import { useToast } from "../../modules/message";
import { PaginationResult, defaultResults } from "../../pagination";
import {
  useOrgaoAetService,
  useOrgaoArtService
} from "../../modules/business/common/commonBusiness";

interface RobosFilasState {
  entity: DashboarPayload | null;
  page: number;
  responseConsulta: boolean;
  responseCadastro: boolean;
  results: PaginationResult<DashboarPayload>;
  loadingFila: boolean;
  orgaosRobo: OrgaoRoboStatusPayload[];
  loadingOrgaos: boolean;
  saldoAntiCaptcha: string | null;
  saldoHcaptcha: string | null;
}

export default defineComponent({
  components: {
    CrudArtEngenheiroTransportador,
    FilaRntrcPainel
  },
  setup() {
    const state = reactive<RobosFilasState>({
      entity: null,
      page: 0,
      responseConsulta: false,
      responseCadastro: false,
      results: defaultResults(),
      loadingFila: false,
      orgaosRobo: [],
      loadingOrgaos: false,
      saldoAntiCaptcha: null,
      saldoHcaptcha: null
    });

    // o painel da Fila ARTS e o proprio CrudArtEngenheiroTransportador; o refresh do cabecalho
    // chama a busca dele
    const filaArtRef = ref<InstanceType<
      typeof CrudArtEngenheiroTransportador
    > | null>(null);

    // painel da Fila RNTRC (as duas filas: solicitação e monitoramento do pagamento)
    const filaRntrcRef = ref<InstanceType<typeof FilaRntrcPainel> | null>(null);

    const amIAllowed = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIAllowed(authority, permissionInfo);
    };

    const executeBuscaStatusConsulta = async () => {
      const { data, isRoboConsultaHabilitado } = useDashboardService();
      await isRoboConsultaHabilitado();
      state.responseConsulta = data.value;
      return data.value;
    };

    const executeBuscaStatusCadastro = async () => {
      const { data, isRoboCadastroHabilitado } = useDashboardService();
      await isRoboCadastroHabilitado();
      state.responseCadastro = data.value;
      return data.value;
    };

    const executeDesligarRoboConsulta = async () => {
      try {
        await useDashboardService().desligarRoboConsulta();
        useToast().success("Robos desligados com sucesso");
        executeBuscaStatusConsulta();
      } catch {
        useToast().error("Falha ao desligar os Robos");
      }
    };

    const executeLigarRoboConsulta = async () => {
      try {
        await useDashboardService().ligarRoboConsulta();
        useToast().success("Robos ligados com sucesso");
        executeBuscaStatusConsulta();
      } catch {
        useToast().error("Falha ao ligar os Robos");
      }
    };

    const executeDesligarRoboCadastro = async () => {
      try {
        await useDashboardService().desligarRoboCadastro();
        useToast().success("Robos desligados com sucesso");
        executeBuscaStatusCadastro();
      } catch {
        useToast().error("Falha ao desligar os Robos");
      }
    };

    const executeLigarRoboCadastro = async () => {
      try {
        await useDashboardService().ligarRoboCadastro();
        useToast().success("Robos ligados com sucesso");
        executeBuscaStatusCadastro();
      } catch {
        useToast().error("Falha ao ligar os Robos");
      }
    };

    const executeBuscaSaldoAntiCaptcha = async () => {
      try {
        const { data, getSaldoAntiCaptcha } = useDashboardService();
        await getSaldoAntiCaptcha();
        state.saldoAntiCaptcha = data.value.balance;
        return state.saldoAntiCaptcha;
      } catch (error) {
        useToast().error("Falha ao buscar saldo AntiCaptcha");
        return null;
      }
    };

    const executeBuscaSaldoHcaptcha = async () => {
      try {
        const { data, getSaldoHcaptcha } = useDashboardService();
        await getSaldoHcaptcha();
        state.saldoHcaptcha = data.value.saldo;
        return state.saldoHcaptcha;
      } catch (error) {
        useToast().error("Falha ao buscar saldo Hcaptcha");
        return null;
      }
    };

    // Tabelinha separada do controle geral (liga/desliga tudo de uma vez),
    // ao lado da tabela por órgão dentro do mesmo painel "Controle de Robôs
    // por Órgão" — mesmo formato (nome colorido + switch) da tabela por
    // órgão. Título da tabela é "Geral"; o nome da linha descreve o que ela
    // controla.
    const controleGeralRows = computed<OrgaoRoboStatusPayload[]>(() => [
      {
        nome: "Robôs Consulta e Cadastro",
        consultaHabilitado: state.responseConsulta,
        cadastroHabilitado: state.responseCadastro
      }
    ]);

    const toggleConsultaGeral = (valor: boolean) => {
      return valor ? executeLigarRoboConsulta() : executeDesligarRoboConsulta();
    };

    const toggleCadastroGeral = (valor: boolean) => {
      return valor ? executeLigarRoboCadastro() : executeDesligarRoboCadastro();
    };

    const executeSearchFilaRobo = () => {
      const { data, getDadosFilaRobo } = useDashboardService();
      state.loadingFila = true;
      return getDadosFilaRobo(state.page)
        .then(() => {
          if (data.value && data.value.content) {
            const resultTratado: DashboarPayload[] = data.value.content.map(
              (item: DashboarPayload, index: number) => {
                item.groupIndex = index;
                return item;
              }
            );
            data.value.content = resultTratado;
            state.results = data.value;
          } else {
            state.results = defaultResults();
          }
        })
        .finally(() => {
          state.loadingFila = false;
        });
    };

    const executeBuscaOrgaosRobo = () => {
      const { data, getOrgaosRoboStatus } = useDashboardService();
      state.loadingOrgaos = true;
      return getOrgaosRoboStatus()
        .then(() => {
          state.orgaosRobo = Array.isArray(data.value) ? data.value : [];
        })
        .finally(() => {
          state.loadingOrgaos = false;
        });
    };

    const orgaoStatusClass = (orgao: OrgaoRoboStatusPayload) => {
      const consulta = !!orgao.consultaHabilitado;
      const cadastro = !!orgao.cadastroHabilitado;
      if (consulta && cadastro) {
        return "orgao-status-on";
      }
      if (!consulta && !cadastro) {
        return "orgao-status-off";
      }
      return "orgao-status-mixed";
    };

    const toggleConsultaOrgao = (
      orgao: OrgaoRoboStatusPayload,
      valor: boolean
    ) => {
      if (!orgao.idOrgao) {
        return;
      }
      const service = useDashboardService();
      const acao = valor
        ? service.ligarRoboConsultaOrgao(orgao.idOrgao)
        : service.desligarRoboConsultaOrgao(orgao.idOrgao);
      acao
        .then(() => {
          useToast().success(
            `Robô de Consulta ${valor ? "ligado" : "desligado"} para ${
              orgao.sigla
            }`
          );
        })
        .finally(() => {
          executeBuscaOrgaosRobo();
        });
    };

    const toggleCadastroOrgao = (
      orgao: OrgaoRoboStatusPayload,
      valor: boolean
    ) => {
      if (!orgao.idOrgao) {
        return;
      }
      const service = useDashboardService();
      const acao = valor
        ? service.ligarRoboCadastroOrgao(orgao.idOrgao)
        : service.desligarRoboCadastroOrgao(orgao.idOrgao);
      acao
        .then(() => {
          useToast().success(
            `Robô de Cadastro ${valor ? "ligado" : "desligado"} para ${
              orgao.sigla
            }`
          );
        })
        .finally(() => {
          executeBuscaOrgaosRobo();
        });
    };

    const getIdOrgaoAetBySigla = (sigla?: string | null) => {
      if (!sigla) {
        return null;
      }
      return (
        useOrgaoAetService()
          .getOrgaosAet()
          .find((o) => o.sigla === sigla)?.idOrgao ?? null
      );
    };

    const getIdOrgaoArtBySigla = (sigla?: string | null) => {
      if (!sigla) {
        return null;
      }
      return (
        useOrgaoArtService()
          .getOrgaosArt()
          .find((o) => o.sigla === sigla)?.idOrgao ?? null
      );
    };

    const getFila = (e?: DashboarPayload) => {
      return useDashboardService().getFila(e);
    };

    const getSigla = (e?: DashboarPayload) => {
      return useDashboardService().getSigla(e);
    };

    const getStatusRobo = (e?: DashboarPayload) => {
      return useDashboardService().getStatusRobo(e);
    };

    const getQuantidade = (e?: DashboarPayload) => {
      return useDashboardService().getQuantidade(e);
    };

    onMounted(() => {
      executeBuscaStatusCadastro();
      executeBuscaStatusConsulta();
      executeSearchFilaRobo();
      executeBuscaOrgaosRobo();
      executeBuscaSaldoAntiCaptcha();
      executeBuscaSaldoHcaptcha();
    });

    return {
      state,
      filaArtRef,
      filaRntrcRef,
      amIAllowed,
      executeBuscaStatusCadastro,
      executeBuscaStatusConsulta,
      executeDesligarRoboConsulta,
      executeLigarRoboConsulta,
      executeDesligarRoboCadastro,
      executeLigarRoboCadastro,
      executeBuscaSaldoAntiCaptcha,
      executeBuscaSaldoHcaptcha,
      controleGeralRows,
      toggleConsultaGeral,
      toggleCadastroGeral,
      executeSearchFilaRobo,
      executeBuscaOrgaosRobo,
      orgaoStatusClass,
      getIdOrgaoAetBySigla,
      getIdOrgaoArtBySigla,
      toggleConsultaOrgao,
      toggleCadastroOrgao,
      getFila,
      getSigla,
      getStatusRobo,
      getQuantidade
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.saldos-captcha {
  display: flex;
  flex-wrap: wrap;
  gap: $space-4;
  margin-bottom: $space-5;
}

.saldo-card {
  display: flex;
  align-items: center;
  gap: $space-3;
  padding: $space-4 $space-5;
  background: $bg-surface;
  border: 1px solid $bg-surface-secondary;
  border-radius: $radius-lg;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  min-width: 240px;
}

.saldo-anticaptcha {
  border-left: 4px solid $info;
}

.saldo-hcaptcha {
  border-left: 4px solid $success;
}

.saldo-icon {
  font-size: $font-size-3xl;
  color: $text-muted;
}

.saldo-anticaptcha .saldo-icon {
  color: $info;
}

.saldo-hcaptcha .saldo-icon {
  color: $success;
}

.saldo-info {
  display: flex;
  flex-direction: column;
}

.saldo-label {
  font-size: $font-size-xs;
  font-weight: $font-weight-semibold;
  color: $text-muted;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.saldo-valor {
  font-size: $font-size-2xl;
  font-weight: $font-weight-bold;
  color: $text-primary;
}

.controle-geral-table {
  margin-bottom: $space-4;
}

.fila-robos-table {
  margin-bottom: $space-4;
}

.fila-robos-panel {
  margin-bottom: $space-4;
}

.fila-art-panel {
  margin-bottom: $space-4;
}

.fila-rntrc-panel {
  margin-bottom: $space-4;
}

.search-result-count {
  font-size: $font-size-xs;
  color: $text-muted;
  background: $bg-surface-secondary;
  padding: $space-1 $space-3;
  border-radius: $radius-full;
  white-space: nowrap;
}

.controle-orgao-panel {
  margin-bottom: $space-4;
}

.orgao-cell {
  display: flex;
  align-items: center;
  gap: $space-2;
}

.orgao-logo {
  flex: 0 0 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.orgao-status-on {
  color: $success;
  font-weight: $font-weight-semibold;
}

.orgao-status-mixed {
  color: $warning;
  font-weight: $font-weight-semibold;
}

.orgao-status-off {
  color: $danger;
  font-weight: $font-weight-semibold;
}
</style>
